import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSession } from '../../stores/session/SessionAction';

function AdminRoute({ children }) {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const sessionAPI = useSession();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        await Promise.resolve(dispatch(sessionAPI.request.get()));
      } finally {
        setIsLoading(false);
      }
    };
    fetchSession();
  }, [dispatch]);

  if (isLoading) return null;
  if (!session?.userSeq) return <Navigate to="/login" replace />;
  if (!session?.isAdmin) return <Navigate to={session?.dashboardPath || '/dashboard'} replace />;

  return children;
}

export default AdminRoute;
